import axios from 'axios';
import qs from 'qs';

const apiClient = axios.create({
  baseURL: `${import.meta.env.VITE_APP_API_URL}`,
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
  responseType: 'json',
});

export default apiClient;
